import React, { FunctionComponent } from 'react';
import { Loader, Message } from 'semantic-ui-react';
import { ContactsTableView } from './contacts-table-view';
import { ListContactItem } from 'generated/api-client';

type ContactsTableContainerProps = {
  error: Error | null;
  loading: boolean;
  contacts?: ListContactItem[];
  orderBy?: {
    column: string;
    direction: 'ascending' | 'descending';
  };
  onSort?: (column: string, direction: string) => void;
};

export const ContactsTableContainer: FunctionComponent<
  ContactsTableContainerProps
> = ({ loading, contacts, error, onSort, orderBy }) => {
  if (error) {
    return (
      <Message negative>
        <Message.Header>
          Erreur lors du chargement des contacts, veuillez en informer le
          service informatique
        </Message.Header>
        <p>{error.message}</p>
      </Message>
    );
  }

  if (loading) {
    return (
      <Loader
        style={{ marginTop: '50px' }}
        size="large"
        active
        inline="centered"
      >
        Chargement...
      </Loader>
    );
  }
  if (!contacts) {
    return <Message>Il n&apos;y a pas de résultats</Message>;
  }

  return (
    <ContactsTableView
      loading={loading}
      contacts={contacts}
      onSort={onSort}
      orderBy={orderBy}
    />
  );
};
